<template>
  <div class="app-container">
    <div
      style="
        background: #fff;
        border-bottom: 2px solid #f2f3f5;
        padding-top: 15px;
      "
    >
      <div class="tab-btn-lin">
        <el-button
          :class="activeName == 1 ? 'selected' : ''"
          @click="handleClick(1)"
          >择校记录</el-button
        >
        <el-button
          :class="activeName == 2 ? 'selected' : ''"
          @click="handleClick(2)"
          >智能推荐</el-button
        >
        <el-button
          :class="activeName == 3 ? 'selected' : ''"
          @click="handleClick(3)"
          >专业推荐</el-button
        >
      </div>
      <div v-if="activeName == 1">
        <el-table
          :data="recordList"
          v-loading="listLoading2"
          element-loading-text="加载中 ..."
          border
          highlight-current-row
          :header-cell-style="{
            backgroundColor: '#ebeef5',
            color: '#303133',
            fontSize: '14px',
            fontWeight: '400',
          }"
          max-height="780"
        >
          <el-table-column
            label="提交/分析时间"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span v-html="toBreak1(scope.row.time_info)"></span>
            </template>
          </el-table-column>
          <el-table-column
            label="择校类型"
            align="center"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>{{ scope.row.mold }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="择校信息"
            min-width="300"
            align="left"
          >
            <template slot-scope="scope">
              <span v-html="toBreak(scope.row.student_info)"></span>
            </template>
          </el-table-column>
          <el-table-column
            label="择校建议"
            width="400"
            align="left"
          >
            <template slot-scope="scope">
              <span v-html="toBreak(scope.row.advice)"></span>
            </template>
          </el-table-column>
          <el-table-column
            label="备注说明"
            width="90"
            align="center"
            prop="remarks"
          ></el-table-column>
          <el-table-column
            label="分析人"
            width="87"
            align="center"
            prop="analyst"
          ></el-table-column>
        </el-table>
        <div class="pagination-container">
          <pagination
            :total="record.count"
            :page.sync="record.page"
            :limit.sync="record.size"
            @pagination="recommendRecord"
          />
        </div>
      </div>
      <div v-if="activeName == 2">
        <div class="tab-content">
          <div class="tab-filter checkbox">
            <p>学历层次</p>
            <el-radio-group v-model="filter.level" @input="getSchool">
                <el-radio
                  :label="item.value"
                  v-for="(item, index) in levelList"
                  :key="index"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
          </div>
          <div class="tab-filter checkbox college">
            <p>就读院校</p>
            <el-select
              clearable
              style="width: 220px"
              filterable
              class="filter-item"
              v-model="filter.school"
              placeholder="请选择"
            >
              <el-option
                v-for="item in shcoolOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="tab-filter checkbox college">
            <p>报考专业</p>
            <el-select
              clearable
              style="width: 220px"
              filterable
              class="filter-item"
              v-model="filter.target_major"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in majorOptions"
                :key="index"
                :label="'(' + item.code + ')' + item.name"
                :value="'(' + item.code + ')' + item.name"
              >
                <span style="float: left">{{
                  "(" + item.code + ")" + item.name
                }}</span>
                <span
                  style="float: right; color: #8492a6; font-size: 13px"
                  v-if="item.level == 1"
                  >一级学科</span
                >
              </el-option>
            </el-select>
          </div>
          <div class="tab-filter checkbox major">
            <p>报考地区</p>
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              class="filter-item"
              @change="handleCheckAllChange"
              >全选</el-checkbox
            >
          </div>
          <div class="tab-filter checkbox area">
            <p>A区</p>
            <el-checkbox-group
              v-model="checkedCities"
              @change="handleCheckedCitiesChange"
            >
              <el-checkbox
                v-for="(city, index) in citiesA"
                :class="(index + 1) % 4 === 0 ? 'mr' : ''"
                :label="city"
                :key="city"
                >{{ city }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div class="tab-filter checkbox area1">
            <p>B区</p>
            <el-checkbox-group
              v-model="checkedCities"
              @change="handleCheckedCitiesChange"
            >
              <el-checkbox
                v-for="(city, index) in citiesB"
                :class="(index + 1) % 4 === 0 ? 'mr' : ''"
                :label="city"
                :key="city"
                >{{ city }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div class="tab-filter checkbox way">
            <p>学习形式</p>
            <el-radio-group v-model="filter.target_way">
              <el-radio
                :label="item.value"
                v-for="(item, index) in wayList"
                :key="index"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </div>
          <div class="tab-filter checkbox college">
            <p>是否跨考</p>
            <el-radio-group v-model="filter.is_cross">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </div>
          <div class="tab-filter checkbox college">
            <p>数学水平</p>
            <el-radio-group v-model="filter.maths_level">
              <el-radio
                :label="item.value"
                v-for="(item, index) in mathsList"
                :key="index"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </div>
          <div class="tab-filter checkbox college">
            <p>英语情况</p>
            <el-radio-group v-model="filter.english_level">
              <el-radio
                :label="item.value"
                v-for="(item, index) in englishList"
                :key="index"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
        <div class="intelligent-btn-line">
          <el-button class="filter-item" type="text" @click="$refs.rule.show()"
            >规则说明</el-button
          >
          <div>
            <el-button class="filter-item" style="color: #909399;" type="text" @click="handleClear"
              >清空</el-button
            >
            <el-button class="filter-item" style="color: #909399;" type="text" @click="$refs.set.show()"
              >设置</el-button
            >
            <el-button class="filter-item" type="primary" @click="handleRecommend"
              >开始推荐</el-button
            >
          </div>
        </div>
      </div>
      <div v-if="activeName == 3">
        <div class="tab-filter checkbox" style="margin-top: 17px">
          <p>本科专业</p>
          <el-cascader
            clearable
            filterable
            style="width: 220px; margin-left: 16px"
            class="filter-item"
            v-model="recommendQuery.ug_major_code"
            :options="majorOptions1"
            placeholder="请输入"
          ></el-cascader>
        </div>
        <div class="intelligent-btn-line1">
          <div>
            <el-button class="filter-item" style="color: #909399;" type="text" @click="handleClear2"
              >清空</el-button
            >
            <el-button class="filter-item" type="primary" @click="handleRecommend"
              >开始推荐</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="activeName == 2 || activeName == 3"
      class="header"
      style="background: #fff; padding: 32px 24px"
    >
      <div class="recList">
        <div class="title">推荐列表</div>
        <div>
          <el-button
            v-if="activeName == 2&&record_id"
            class="filter-item"
            style="margin-right: 24px"
            type="text"
            @click="$refs.record.show(uuid,record_id)"
            >推送记录</el-button
          >
          <el-button
            v-if="activeName == 2"
            class="filter-item"
            type="text"
            @click="handleCompare"
            >一键对比</el-button
          >
        </div>
      </div>
      <el-table
        v-if="activeName == 2"
        :data="recommendList"
        v-loading="listLoading1"
        element-loading-text="加载中 ..."
        border
        highlight-current-row
        :header-cell-style="{
          backgroundColor: '#ebeef5',
          color: '#303133',
          fontSize: '14px',
          fontWeight: '400',
        }"
        max-height="342"
      >
        <el-table-column
          label="推荐"
          width="60"
          align="center"
          prop="rec_tag"
        ></el-table-column>
        <el-table-column
          label="省份"
          width="120"
          align="center"
          prop="city"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="专业名称/代码"
          min-width="160"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <router-link
              class="link"
              :to="`/apply/major-info-new/${scope.row.id}`"
              target="_blank"
              v-if="checkPermission(['query.view_search_catalog_admin'])"
              >{{ scope.row.major }}</router-link
            >
            <div v-else>
              {{ scope.row.major }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="院校名称" prop="school_name" width="230" align="center" show-overflow-tooltip />
        <el-table-column 
          label="院校层次" 
          width="95"
          align="center"
          show-overflow-tooltip
          prop="level" 
        />
        <el-table-column
          label="院系"
          width="160"
          prop="department"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="考试方式"
          width="160"
          prop="ex_type"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="学习形式"
          width="160"
          prop="way"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="专业排名"
          width="140"
          align="center"
          prop="major_rank"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="学科等级"
          width="120"
          align="center"
          prop="major_eval"
        >
        </el-table-column>
        <el-table-column
          label="拟招生人数"
          width="160"
          align="center"
          prop="enroll"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-table
        v-if="activeName == 3"
        :data="recommendList"
        v-loading="listLoading1"
        element-loading-text="加载中 ..."
        key="one"
        border
        highlight-current-row
        :header-cell-style="{
          backgroundColor: '#ebeef5',
          color: '#303133',
          fontSize: '14px',
          fontWeight: '400',
        }"
        max-height="342"
      >
        <el-table-column
          label="序号"
          width="108"
          align="center"
          key="one"
          type="index"
        ></el-table-column>
        <el-table-column
          label="门类"
          width="149"
          align="center"
          prop="major_0"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="一级学科"
          width="186"
          prop="major_1"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="专业"
          min-width="190"
          align="center"
          prop="major"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="开设院校数量"
          width="158"
          align="center"
          prop="school_num"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="181" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="viewDepartment(scope.row)"
              >查看院校</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container" v-if="activeName == 3">
        <pagination
          :total="recommendQuery.count"
          :page.sync="recommendQuery.page"
          :limit.sync="recommendQuery.size"
          @pagination="getRecommend"
        />
      </div>
    </div>
    <div
      v-if="activeName == 2 || activeName == 3"
      class="main"
      style="background: #fff"
    >
      <div class="more">
        <div>专业推荐</div>
      </div>
      <div class="filter-container">
        <major-filter
          ref="major"
          @clear="handleClear1"
          @filter="handleFilter"
          @set="$refs.newIndex.show()"
        ></major-filter>
      </div>
      <el-table
        :data="list"
        v-loading="listLoading"
        element-loading-text="加载中 ..."
        border
        @sort-change="changeSort"
        highlight-current-row
        :header-cell-style="{
          backgroundColor: '#ebeef5',
          color: '#303133',
          fontSize: '14px',
          fontWeight: '400',
        }"
        max-height="550"
      >
        <el-table-column
          label="省份/城市"
          width="159"
          align="center"
          prop="city"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="院校名称"
          align="center"
          width="180"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>{{ scope.row.school }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="专业名称/代码"
          min-width="240"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <router-link
              class="link"
              :to="`/apply/major-info-new/${scope.row.id}`"
              target="_blank"
              v-if="checkPermission(['query.view_enquiry_admin'])"
              >{{ scope.row.major }}</router-link
            >
            <div v-else>
              {{ scope.row.major }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="院系"
          width="169"
          align="center"
          prop="department"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="考试方式"
          width="86"
          align="center"
          prop="ex_type"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="学习形式"
          width="86"
          align="center"
          prop="way"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="学科等级"
          width="110"
          align="center"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.major_eval }}
          </template>
        </el-table-column>
        <el-table-column
          label="拟招生人数"
          width="124"
          align="center"
          sortable
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.enroll }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <pagination
          :total="count"
          :page.sync="params.page"
          :limit.sync="params.size"
          @pagination="fetchData"
        />
      </div>
    </div>

    <!-- 参考书目 -->
    <book-list ref="bookList"></book-list>

    <!-- 加入对比弹窗 -->
    <contrast ref="contrast" :year="listQuery.year"></contrast>

    <rule ref="rule" :type="2"></rule>
    <setting
      ref="set"
      @handleSet="handleSet"
      :target_major="filter.target_major"
      :resource="filter.is_exclude_major"
      :type="filter.target_school_attr"
    ></setting>
    <new-index ref="newIndex" @refresh="refresh"></new-index>
    <record ref="record"></record>
  </div>
</template>

<script>
import {
  getYear,
  getSearchUgMajor,
  getRecommendSchoolParams,
  getUgSchool,
  getUgMajor,
  postRecommendSchool,
} from "@/api/common";
import {
  getSearchCatalogList,
  getRecommendMajor,
  getRecommendRecord,
  getRecommendUserInfo
} from "@/api/apply";
import checkPermission from "@/utils/permission";
import BookList from "./components/BookList";
import Contrast from "./components/Contrast";
import MajorFilter from "@/components/MajorFilter";
import Rule from "./components/recommend/rule";
import Setting from "./components/recommend/setting";
import NewIndex from "./components/new-index/index";
import Record from "./components/recommend/record";

export default {
  name: "ApplyIndex",
  data() {
    return {
      uuid: "",
      recordList: [],
      list: [],
      recommendList: [],
      count: 0,
      listLoading: true,
      listLoading1: false,
      listLoading2: true,
      attr: [],
      level: [],
      mold: [],
      activeName: "1",
      lastActiveName: "1",
      area: [],
      areaOptions: [], //省份/城市
      categoryOptions: [], //门类/一级学科
      recommendQuery: {
        ug_major_code: [],
        count: 0,
        page: 1,
        size: 50,
      },
      record: {
        count: 0,
        page: 1,
        size: 50
      },
      regionOptions: [
        { label: "华北", value: 1 },
        { label: "东北", value: 2 },
        { label: "华东", value: 3 },
        { label: "华中", value: 4 },
        { label: "华南", value: 5 },
        { label: "西南", value: 6 },
        { label: "西北", value: 7 },
      ],
      doctoralOptions: [
        { label: "有", value: 1 },
        { label: "无", value: 2 },
      ],
      degreeOptions: [
        { label: "接受", value: 1 },
        { label: "不接受", value: 2 },
      ],
      checkAll: false,
      isIndeterminate: false,
      checkedCities: [],
      shcoolOptions: null,
      citiesOptions: [
        "北京市",
        "天津市",
        "河北省",
        "山西省",
        "吉林省",
        "黑龙江省",
        "上海市",
        "江苏省",
        "浙江省",
        "安徽省",
        "福建省",
        "江西省",
        "山东省",
        "河南省",
        "湖北省",
        "湖南省",
        "广东省",
        "重庆市",
        "四川省",
        "陕西省",
        "内蒙古",
        "广西省",
        "海南省",
        "贵州省",
        "云南省",
        "新疆",
        "西藏",
        "甘肃省",
        "青海省",
        "宁夏省",
      ],
      citiesA: [
        { lable: "北京市", value: 1 },
        { lable: "天津市", value: 2 },
        { lable: "河北省", value: 3 },
        { lable: "山西省", value: 4 },
        { lable: "吉林省", value: 5 },
        { lable: "黑龙江省", value: 6 },
        { lable: "上海市", value: 7 },
        { lable: "江苏省", value: 8 },
        { lable: "浙江省", value: 9 },
        { lable: "安徽省", value: 10 },
        { lable: "福建省", value: 11 },
        { lable: "江西省", value: 12 },
        { lable: "山东省", value: 13 },
        { lable: "河南省", value: 14 },
        { lable: "湖北省", value: 15 },
        { lable: "湖南省", value: 16 },
        { lable: "广东省", value: 17 },
        { lable: "重庆市", value: 18 },
        { lable: "四川省", value: 19 },
        { lable: "陕西省", value: 20 },
      ],
      citiesB: [
        { lable: "内蒙古", value: 1 },
        { lable: "广西省", value: 2 },
        { lable: "海南省", value: 3 },
        { lable: "贵州省", value: 4 },
        { lable: "云南省", value: 5 },
        { lable: "新疆", value: 6 },
        { lable: "西藏", value: 7 },
        { lable: "甘肃省", value: 8 },
        { lable: "青海省", value: 9 },
        { lable: "宁夏省", value: 10 },
      ],
      filter: {
        level: 1,
        school: "",
        target_way: 1,
        is_cross: false,
        target_major: "",
        target_area: "",
        maths_level: 2,
        english_level: 2,
        target_school_attr: "1",
        is_exclude_major: true
      },
      params: {
        page: 1,
        size: 50,
        year: "",
        city: "",
        school: "",
        major: "",
        requirement: "",
        major_eval: "",
        speciality: "",
        maths: "",
        language: "",
        ex_type: "",
        way: "",
        book: "",
        school_level: "",
        school_mold: "",
        school_attr: "",
        major_category: "",
        direction: "",
        department: "",
      },
      yearOptions: null,
      listQuery: {
        page: 1,
        size: 50,
        year: "",
        city: "",
        school: "",
        major: "",
        requirement: "",
        major_eval: "",
        speciality: "",
        maths: "",
        language: "",
        ex_type: "",
        way: "",
        book: "",
        school_level: "",
        school_mold: "",
        school_attr: "",
        major_category: "",
        direction: "",
        department: "",
      },
      moldList: [
        "综合类",
        "理工类",
        "财经类",
        "政法类",
        "师范类",
        "语言类",
        "农林类",
        "医药类",
        "军事类",
        "体育类",
        "民族类",
        "艺术类",
      ],
      record_id: null,
    };
  },
  components: {
    BookList,
    Contrast,
    Setting,
    Rule,
    NewIndex,
    MajorFilter,
    Record,
  },
  created() {
    this.$store.dispatch('CloseSideBar', { withoutAnimation: false })
    this.uuid = this.$route.query.uuid;
    this.filter.student_id = this.$route.query.uuid;
    getRecommendSchoolParams().then((res) => {
      this.englishList = res.data.english;
      this.mathsList = res.data.maths;
      this.citiesA = res.data.area.A;
      this.citiesB = res.data.area.B;
      this.levelList = res.data.level;
      this.wayList = res.data.way;
      this.citiesOptions = this.citiesA.concat(this.citiesB);
    });

    getUgMajor().then((res) => {
      this.majorOptions = res.data;
    });
    getYear().then((res) => {
      this.yearOptions = res.data;
      this.listQuery.year = res.data[0];
      this.params = this.listQuery;
      this.getSchool();
      this.fetchData();
    });
    getSearchUgMajor().then((res) => {
      res.data.forEach((item) => {
        item.label = item.name;
        item.value = item.code;
        if (item.children && item.children.length > 0) {
          item.children.forEach((major) => {
            major.label = major.name;
            major.value = major.code;
            if (major.children && major.children.length > 0) {
              major.children.forEach((major1) => {
                major1.label = major1.name;
                major1.value = major1.code;
              });
            }
          });
        }
      });
      this.majorOptions1 = res.data;
    });
    this.recommendRecord()
  },
  methods: {
    checkPermission,
    refresh() {
      this.$refs.major.getSearchSet();
    },
    // 择校记录-择校信息换行
    toBreak(val) {
      return val.replaceAll('；', '；<br>')
    },
    // 择校记录-提交/分析时间
    toBreak1(val) {
      return val.replaceAll('/', '/<br>')
    },
    // 用户最近一次填写的数据回填
    recommendUserInfo() {
      getRecommendUserInfo({ student_id: this.uuid }).then(res => {
        this.filter.english_level = res.data.english_level ? res.data.english_level : this.filter.english_level
        this.filter.is_cross = res.data.is_cross!==null ? res.data.is_cross : this.filter.is_cross
        this.filter.is_exclude_major = res.data.is_exclude_major!==null ? res.data.is_exclude_major : this.filter.is_exclude_major
        this.filter.level = res.data.level ? res.data.level : this.filter.level
        this.filter.maths_level = res.data.maths_level ? res.data.maths_level : this.filter.maths_level
        this.filter.school = res.data.school ? res.data.school : this.filter.school
        this.filter.target_area = res.data.target_area ? res.data.target_area : this.filter.target_area
        this.filter.target_major = res.data.target_major ? res.data.target_major : this.filter.target_major
        this.filter.target_school_attr = res.data.target_school_attr ? res.data.target_school_attr : this.filter.target_school_attr
        this.filter.target_way = res.data.target_way ? res.data.target_way : this.filter.target_way
        this.checkedCities = res.data.target_area?res.data.target_area.split('、'):[]
        this.checkAll =
          this.checkedCities.length === this.citiesA.length + this.citiesB.length;
        this.isIndeterminate =
          this.checkedCities.length > 0 &&
          this.checkedCities.length < this.citiesA.length + this.citiesB.length;
      })
    },
    // 择校记录
    recommendRecord() {
      let { page, size } = this.record;
      this.listLoading2 = true
      getRecommendRecord({ student_id: this.uuid, page, size }).then((res) => {
        this.record.count = res.data.count
        this.recordList = res.data.results
        this.listLoading2 = false
      });
    },
    // 查看院校
    viewDepartment(row) {
      this.$refs.major.viewSchool(row);
    },
    // 获取数据
    fetchData() {
      this.listLoading = true;
      getSearchCatalogList(this.params).then((res) => {
        this.list = res.data.results;
        this.count = res.data.count;
        this.listLoading = false;
      });
    },
    getSchool() {
      getUgSchool({ level: this.filter.level }).then((res) => {
        this.shcoolOptions = res.data;
      });
    },
    //一键对比
    handleCompare() {
      let list = [];
      this.recommendList.forEach((item) => {
        let obj = {};
        obj.school = item.school_name;
        obj.major_name_key = item.major_compare_key.split("/");
        obj.major_name = obj.major_name_key[1] + "/" + obj.major_name_key[2];
        obj.way_code = item.way_code;
        obj.ex_type_code = item.ex_type_code;
        list.push(obj);
      });
      localStorage.setItem("majorList", JSON.stringify(list));
      localStorage.setItem("majorListYearNum", 1);
      let routeDate = this.$router.resolve({ path: "/apply/major-contrast" });
      window.open(routeDate.href, '_blank')
    },
    // 地区全选
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.citiesOptions : [];
      this.filter.target_area = val ? this.citiesOptions.join("、") : [];
      this.isIndeterminate = false;
    },
    // 地区多选
    handleCheckedCitiesChange(val) {
      let checkedCount = val.length;
      this.filter.target_area = val.join("、");
      this.checkAll =
        checkedCount === this.citiesA.length + this.citiesB.length;
      this.isIndeterminate =
        checkedCount > 0 &&
        checkedCount < this.citiesA.length + this.citiesB.length;
    },
    // 专业推荐清空
    handleClear2() {
      this.recommendQuery.ug_major_code = ""
    },
    // 清空
    handleClear() {
      this.checkedCities = [];
      this.isIndeterminate = false;
      this.checkAll = false;
      this.filter = {
        level: 1,
        school: "",
        target_way: 1,
        is_cross: false,
        target_major: "",
        target_area: "",
        maths_level: 2,
        english_level: 2,
        target_school_attr: "1",
      };
    },
    // 清空专业推荐筛选项
    handleClear1() {
      this.params = {
        page: 1,
        size: 50,
        year: this.yearOptions[0],
        city: "",
        school: "",
        major: "",
        requirement: "",
        major_eval: "",
        speciality: "",
        maths: "",
        language: "",
        ex_type: "",
        way: "",
        book: "",
        school_level: "",
        school_mold: "",
        school_attr: "",
        major_category: "",
        direction: "",
        department: "",
      };
    },
    // 切换推荐类型
    handleClick(tab) {
      this.activeName = tab
      if (this.lastActiveName != tab) {
        if (tab == '1') {
          this.recommendRecord()
        }
        if (tab == '2') {
          this.recommendUserInfo()
        }
        if (this.lastActiveName != '1') {
          this.recommendList = [];
          this.$refs.major.handleClear();
          this.fetchData();
        }
        this.lastActiveName = tab;
      }
    },
    // 智能推荐-左侧设置
    handleSet(data) {
      this.filter.target_school_attr = data.type.join(",");
      this.filter.is_exclude_major = data.resource == '1'?true:false
    },
    // 开始推荐
    handleRecommend() {
      if (this.activeName == "3") {
        this.getRecommend();
      } else if (this.activeName == "2") {
        if (this.filter.school == '' || this.filter.target_major == '' || this.filter.target_area == '') {
          this.$message({
            message: '请先选好推荐条件！',
            type: 'warning'
          });
          return
        }
        this.filter.is_cross = this.filter.is_cross ? true : false;
        this.recommendList = [];
        this.listLoading1 = true;
        this.params.major = this.filter.target_major;
        this.$refs.major.changeFilter(this.filter);
        postRecommendSchool(this.filter).then((res) => {
          this.record_id = res.data.record_id
          this.recommendList = res.data.recommend
          this.listLoading1 = false;
        });
      }
    },
    // 更多专业排序
    changeSort({column,order}) {
      this.order = order
      if (column.label == '学科等级') {
        this.params.sort = order=='ascending'? 'major_eval' : order=='descending' ? '-major_eval' : ''
      } else {
        this.params.sort = order=='ascending'? 'enroll' : order=='descending' ? '-enroll' : ''
      }
      this.fetchData()
    },
    // 专业推荐
    getRecommend() {
      let { page, size } = this.recommendQuery;
      let ug_major_code =
        this.recommendQuery.ug_major_code.length > 0
          ? this.recommendQuery.ug_major_code[
              this.recommendQuery.ug_major_code.length - 1
            ]
          : this.recommendQuery.ug_major_code[0];
      this.listLoading1 = true;
      getRecommendMajor({ ug_major_code, page, size }).then((res) => {
        this.recommendQuery.count = res.data.count;
        this.recommendList = res.data.results;
        this.listLoading1 = false;
      });
    },
    // 筛选
    handleFilter(data) {
      this.params = data;
      this.fetchData();
    },
  },
};
</script>

<style lang="less" scoped>
.tab-btn-lin {
  margin-left: 19px;
  margin-bottom: 24px;
  .selected {
    background: #1989fa;
    border: none;
    color: #ffffff;
  }
}
p {
  margin: 0;
  padding: 0;
}
.app-container {
  padding: 16px;
  background-color: #f2f3f5;
}
.aside {
  background: #ffffff;
  position: relative;
}
/deep/ .el-tabs__nav-wrap {
  padding: 0 24px !important;
}
.tab-filter.checkbox {
  display: flex;
  p {
    width: 60px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #606266;
    margin-top: 9px;
    margin-left: 24px;
    text-align: right;
  }
  .el-radio-group {
    width: 905px;
    margin-left: 24px;
    .el-radio {
      margin-top: 13px;
    }
  }
  .el-checkbox-group {
    width: 905px;
    margin-left: 24px;
    display: flex;
    flex-wrap: wrap;
    .el-checkbox {
      // width: 80px;
      margin-right: 18px;
    }
    .el-checkbox__label {
      padding-left: 6px;
    }
    // .mr {
    //   margin-right: 0;
    // }
  }
}
.area {
  margin-top: 17px;
  p {
    margin-top: 0 !important;
    color: #909399 !important;
  }
}
.area1 {
  margin-top: 23px;
  p {
    margin-top: 0 !important;
    color: #909399 !important;
  }
}
.way {
  margin-top: 21px;
}
.college {
  margin-top: 24px;
  .filter-item {
    margin-left: 16px;
  }
}
.major {
  margin-top: 15px;
  .filter-item {
    margin-left: 24px;
    margin-top: 9px;
  }
}
.intelligent-btn-line {
  margin: 31px 24px 32px;
  display: flex;
  justify-content: space-between;
}
.intelligent-btn-line1 {
  display: flex;
  flex-direction: row-reverse;
  margin: 80px 24px 32px;
}
.container {
  margin-left: 10px;
}
.header {
  min-height: 200px !important;
  background: #ffffff;
  padding: 31px 24px 24px;
  border-bottom: 2px solid #f2f3f5;
  .recList {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .title {
      font-size: 18px;
      color: #303133;
      font-weight: bold;
    }
  }
  .el-button--text {
    padding: 0;
  }
}
.main {
  background: #ffffff;
  padding: 32px 24px;
  .more {
    font-size: 18px;
    color: #303133;
    font-weight: bold;
  }
  .filter-btn {
    display: flex;
    flex-direction: row-reverse;
  }
  .filter-container {
    margin-top: 20px;
  }
  .pagination-container {
    flex-direction: row-reverse;
  }
}
.link {
  color: #409eff;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  &:hover {
    cursor: pointer;
  }
}
</style>
